import { SubnetSopNodeLike } from "../subnet/ChildrenDisplayController";
import { PolyNodeParamsConfig } from "../../../utils/poly/PolyNodeParamsConfig";
export function createPolySopNode(nodeType, definition, polyNodeControllerClass) {
  const ParamsConfig = PolyNodeParamsConfig.ParamsConfig(definition);
  class BasePolySopNode extends SubnetSopNodeLike {
    constructor() {
      super(...arguments);
      this.paramsConfig = ParamsConfig;
      this.polyNodeController = new polyNodeControllerClass(this, definition);
    }
    static type() {
      return nodeType;
    }
  }
  return BasePolySopNode;
}
